// removed by extract-text-webpack-plugin
module.exports = {"LoginForm":"_3aVw8pkxeSDA3PA3ne3B7W","LoginForm__fields":"_21NziaSXM0HzEjFsZABxav","LoginForm__input--email":"_2E8STq-V96Vx3rwf65P_8_","LoginForm__input--password":"_2EDoCpBID0lEx3fOqkVqR8","LoginForm__emailMessage":"_2189Y71CiQGfzKkOlXV2Nm","LoginForm__action":"ksCr8Txt-Pn1qnZ9o98OF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/LoginForm.scss
// module id = 2732
// module chunks = 0